export default function UniqueBy(a, ...keys) {
  const seen = new Set();
  return a.filter(item => {
    const key = keys.map(k => item[k]).join('|');
    return seen.has(key) ? false : seen.add(key);
  });
}
